import ApiService from "@/service/ApiService.ts";
import Cookies from 'js-cookie';

export class AuthenticationService extends ApiService {
    async login(email: string, password: string): Promise<{token:string}> {
        const response = await this.post('/api/authentication/login', { email, password });
        
        if (!response.ok) {
            const error = await response.json();
            return Promise.reject(error);
        }

        const payload = await response.json();
        Cookies.set('mat', payload.token);
        return payload;
    }

    async resetPassword(email: string): Promise<void> {
        const response = await this.post('/api/authentication/reset-password/', { email });

        if (!response.ok) {
            const error = await response.json();
            return Promise.reject(error);
        }
    }

    logout() {
        Cookies.remove('mat');
    }
}